define(
    'models/breadcrumbs.model',[
        'loader',
        'config',
        'helper',
        'sandbox'
    ],
    function (
        Loader,
        Config,
        Helper,
        Sandbox
        )
    {
        var _ = Loader._;

        var BreadcrumbsModel = Loader.Backbone.Model.extend({

            defaults: {
                crumbs: {
                    '': '{forumName}'
                }
            },

            initialize: function()
            {
                var _this = this;
                this.model = this.get('model');

                this.bind('change', function(){
                    _this.trigger('update');
                });
            },

            setCrumbs: function(data)
            {
                var defaultData = this.defaults.crumbs;
                if (_.size(data) > 0) {
                    defaultData['/'] = defaultData[''];
                    delete defaultData[''];
                }
                _.extend(defaultData, data);
                this.set('crumbs', defaultData);
                this.trigger('change');
            }

        });

        return {
            initialize: function(model)
            {
                return new BreadcrumbsModel({
                    model: model
                })
            }
        }
    }
);

